import React, {Component} from "react";
import {Dropdown} from 'semantic-ui-react'
import {withLocalize} from "react-localize-redux";
import {defaultLanguage} from "../pages/Home";

class LanguageDropdown extends Component {
  changeLanguage = (e, data) => {
    this.props.setActiveLanguage(data.value);
  };

  languageOptions = [
    { key: 'English', text: 'English', value: 'en' },
    { key: 'Japanese', text: '日本語', value: 'ja' }
  ];

  render() {
    return (
      <Dropdown
        button
        labeled
        className='icon'
        floating
        icon='world'
        options={this.languageOptions}
        defaultValue={defaultLanguage()}
        onChange={this.changeLanguage}
      />
    )
  }
}

export default withLocalize(LanguageDropdown);


// WEBPACK FOOTER //
// ./src/localisation/LanguageDropdown.js